import { useMemo, useState } from "react"

import { CustomItem, UsePopoverSelectProps, UsePopoverSelectRes } from "./types"
import usePopoverSelect from "./usePopoverSelect"

export type UseLocalSearchPopoverSelectProps<T> = Omit<
  UsePopoverSelectProps<T>,
  "onChangeQuery"
> & {
  buildCustomItems?: (query: string) => CustomItem[]
}

export type UseLocalSearchPopoverSelectRes<T> = UsePopoverSelectRes<T>

function useLocalSearchPopoverSelect<T>(
  props: UseLocalSearchPopoverSelectProps<T>
): UseLocalSearchPopoverSelectRes<T> {
  const {
    items,
    labelExtractor,
    filterExtractor,
    buildCustomItems,
    customItems,
  } = props

  const [query, setQuery] = useState("")

  const filteredItems = useMemo(() => {
    const extractor = filterExtractor ?? labelExtractor
    return items.filter((item) =>
      extractor(item).toLowerCase().includes(query.toLowerCase())
    )
  }, [items, labelExtractor, filterExtractor, query])

  return usePopoverSelect({
    ...props,
    items: filteredItems,
    onChangeQuery: setQuery,
    customItems: [...(customItems ?? []), ...(buildCustomItems?.(query) ?? [])],
  })
}

export default useLocalSearchPopoverSelect
